import classNames from "classnames";
import styles from "./index.module.scss";
import { memberList } from '@/apis/about'
import { useEffect, useMemo, useState } from "react";
import { Tooltip } from "antd";
import intl from "react-intl-universal";

const MembersList = () => {
	const [list, setList] = useState([]);
	const getList = () => {
		memberList().then(res => {
			setList(res.data || [])
		}).catch(err => { })
	}
	useEffect(() => {
		getList()
	}, [])

	const lang = useMemo(() => {
		return localStorage.getItem("lang") || "en-US"
	}, [])

	return (
		<div className={classNames("container", styles.membersListBox)}>
			{/* <p className={styles.titleBox}>{intl.get("About.Community Members")}</p> */}
			<div className={styles.listBox}>
				<p className={styles.titleBox}>{intl.get("About.Users From")}（{list.length}）</p>
				<div className={classNames("flex_box", "flex_wrap")}>
					{list.map((item, index) => {
						return (
							<Tooltip key={index + "_mList"} title={lang === "en-US" ? item.nameEn : item.name}>
								<div
									className={classNames("flex_box", "align_center", "flex_center")}
									onClick={() => {
										window.open(item.url, "_blank")
									}}
								>
									<img src={process.env.REACT_APP_API_AFFIX + item.imgPath} alt="" />
								</div>
							</Tooltip>
						)
					})}
				</div>
			</div>
		</div>
	)
}
export default MembersList